import { render, staticRenderFns } from "./DashboardCountPadrillosAndMadrillas.vue?vue&type=template&id=3346974e&scoped=true"
import script from "./DashboardCountPadrillosAndMadrillas.vue?vue&type=script&lang=js"
export * from "./DashboardCountPadrillosAndMadrillas.vue?vue&type=script&lang=js"
import style0 from "./DashboardCountPadrillosAndMadrillas.vue?vue&type=style&index=0&id=3346974e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3346974e",
  null
  
)

export default component.exports